import { render, staticRenderFns } from "./CardSection.vue?vue&type=template&id=195cbea0&"
import script from "./CardSection.vue?vue&type=script&lang=ts&"
export * from "./CardSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports